export default "__VITE_ASSET__73bfe81f__"